module.exports = __webpack_public_path__ + "img/hexagon.003be7a8.svg";